// Базовые URL конфигурации
const API_PROTOCOL = process.env.VUE_APP_API_PROTOCOL || 'https';
const BASE_DOMAIN = process.env.VUE_APP_API_HOST || 'dev.ludivpluse.ru';
const WS_PROTOCOL = process.env.VUE_APP_WS_PROTOCOL || 'wss';

// Основные URL константы
export const API_URL = `${API_PROTOCOL}://${BASE_DOMAIN}/api`;
export const WS_URL = `${WS_PROTOCOL}://${BASE_DOMAIN}/ws/`;

// Вспомогательные константы для игр
export const WS_URL_LOBBY = `${WS_PROTOCOL}://${BASE_DOMAIN}/ws/lobby/`;

// Функции для создания URL игр
export const getGameWsUrl = (gameId) =>
    `${WS_PROTOCOL}://${BASE_DOMAIN}/ws/game/${gameId}/`;
export const getNotificationUrl = () => `${API_URL}/notification/`;

// Firebase конфигурация
export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyC-2OGl_Wo9KuMYn2AcsooB5mU46ScSRZ0",
    authDomain: "testlubivpluse.firebaseapp.com",
    projectId: "testlubivpluse",
    storageBucket: "testlubivpluse.firebasestorage.app",
    messagingSenderId: "263082252225",
    appId: "1:263082252225:web:05aa183976ce4443724140",
    measurementId: "G-V1XBNDH6WT"
};
